import api, { setAuth } from './api';

const getAccount = () => api.post('/wallet');

const setToken = async () => {
  await setAuth();
};

export default { getAccount, setToken };
